var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rights"},[(_vm.initialized && _vm.contextIsReady(_vm.context))?_c('admin-rights',{attrs:{"role":_vm.role,"links":_vm.rightsLinks}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }